import { Box, CircularProgress } from '@mui/material';
import { Suspense } from 'react';

const SuspenseWrapper = ({ children }: { children: React.ReactNode }) => {
  const fallback = (
    <Box
      display="flex"
      height="100vh"
      justifyContent="center"
      alignItems="center"
    >
      <CircularProgress size={24} />
    </Box>
  );

  return <Suspense fallback={fallback}>{children}</Suspense>;
};
export default SuspenseWrapper;
